import React from 'react'
import clsx from 'clsx'
import Image from 'components/Image/SimpleImage'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import Markdown from 'react-markdown'
import { motion } from 'framer-motion'
import { Element } from 'react-scroll'
import { ensureGetData } from 'lib/helpers'
import { Container, Columns, Column } from 'bloomer'
import { useInView } from 'react-intersection-observer'
import { useMediaQuery } from 'react-responsive'

// Motion Variants
import * as motionVariants from './motion.variants'

// Styles
import styles from './style.module.scss'
import ensureBasePath from '../../../lib/ensureBasePath'

export const WhoWeAre = ({ data, sectionTitle }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' })
  const [currentSlide, setCurrentSlide] = React.useState(1)
  const [ref] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  const checkDecimal = x => (x < 10 ? `0${x}` : 0)

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, newIndex) => {
      setCurrentSlide(newIndex + 1)
    },
  }

  return (
    <Element name="who-we-are">
      <motion.div
        variants={motionVariants.container}
        initial="hidden"
        animate="visible"
        exit="hidden">
        <div id="who-we-are" className={clsx('nav-anchor')}>
          <div className={clsx(styles.section)} ref={ref}>
            {isDesktop && (
              <Image
                alt=""
                quality={35}
                layout="fill"
                objectFit="cover"
                src={ensureGetData(data, 'background', ensureBasePath('/images/about/bg-who-we-are.jpg'), background => background.url)}
              />
            )}
            <div className={styles.container_wrapper}>
              <Container>
                <Columns>
                  <Column isSize={{ mobile: 12, tablet: 6 }} className={styles.section_content}>
                    <div className={styles.content_inner}>
                      <h2 className={clsx('section-title', styles.section_title)}>
                        {sectionTitle}
                      </h2>

                      <div className={styles.slider_outer}>
                        <div className={styles.slider_inner}>
                          <Slider {...sliderSettings} className="slider-who-we-are">
                            {ensureGetData(data, 'content', []).map(post => (
                              <div key={post.id}>
                                <h3 className={clsx('section-subtitle', styles.slide_item_title)}>
                                  {post.title}
                                </h3>
                                <Markdown
                                  source={post.description}
                                  className={clsx('section-copy', styles.slide_item_content)}
                                />
                              </div>
                            ))}
                          </Slider>

                          <div className={styles.slider_nav}>
                            <span className={styles.current_slide}>
                              {checkDecimal(currentSlide)}
                            </span>
                            <span className={styles.divider}>/</span>
                            <span className={styles.total_slide}>
                              {checkDecimal(ensureGetData(data, 'content', []).length)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Column>
                </Columns>
              </Container>
            </div>
          </div>
        </div>
      </motion.div>
    </Element>
  )
}

WhoWeAre.propTypes = {
  data: PropTypes.object.isRequired,
  sectionTitle: PropTypes.string,
}

WhoWeAre.defaultProps = {
  sectionTitle: 'WHO WE ARE',
  data: {},
}

export default WhoWeAre
